import React from 'react';
import {
    Button, Form, FormGroup, Label,
    Col,
    Container, Row
} from 'reactstrap';

import SelectListComponent from '../../utils/selectList';
import DateSelector from '../../utils/dateSelector';


const RateHistoryPanel = ({ categories, selectedCat, multiOptions, multiLabelKey, multiValueKey, multiArray, onCatValueChange, onMultiValueChange, onSearch, startDateChange, endDateChange, airlineSelectNotification }) => {
    return (
        <Form onSubmit={e => e.preventDefault()}>
            <Container>
                <Row>
                    <Col xs="3" sm="2">
                        <FormGroup className="mb-4">
                            <Label>Start Date</Label>
                            <DateSelector 
                            maxDate={new Date()}
                            todayDate={(new Date()).toString()}
                            name="startDate" onValueChange={startDateChange} />
                        </FormGroup>
                    </Col>
                    <Col xs="3" sm="2">
                        <FormGroup className="mb-4">
                            <Label>End Date</Label>
                            <DateSelector 
                            maxDate={new Date()}
                            todayDate={(new Date()).toString()}
                            name="endDate" onValueChange={endDateChange} />
                        </FormGroup>
                    </Col>
                    <Col xs="3" sm="3">
                        <FormGroup className="mb-4">
                            <Label>Currency code</Label>
                            <SelectListComponent data={categories} valueKey='value' textField='label' selectValue={selectedCat} onValueChange={onCatValueChange} />
                        </FormGroup>
                    </Col>
                    <Col xs="3" sm="3">
                        <FormGroup className="">
                            <Label>Country code</Label>
                            <SelectListComponent data={multiOptions} multiSelectMode={true} selectValue={multiArray} valueKey={multiValueKey} textField={multiLabelKey} onValueChange={onMultiValueChange} />
                        </FormGroup>
                    </Col>
                   
                    <Col xs="3" sm="2">
                        <label>&nbsp;</label>
                        <Button className="btn-avi-primary mt-4 mr-5" onClick={() => onSearch(1)}>Search</Button>
                    </Col>
                </Row>
            </Container>
            
        </Form>
    )
};



export default RateHistoryPanel;



// WEBPACK FOOTER //
// ./src/views/exchange-rate/RateHistory/RateHistoryPanel.js